import { Avatar, Flex, Stack, Text } from '@chakra-ui/react'
import { Search } from 'components/icons'
import { FeatureNotYetAvailable } from 'components/miscellaneous'

import { User } from 'UnifiedLogin/types'
import { cpfMask } from 'utils/masks'
import { capitalizeString } from 'utils/transforms/string'

type Props = {
  currentUser: User
}

export default function MessageCenterHeader({ currentUser }: Props) {
  return (
    <Flex p={2} px={4} align="center" justify="space-between" borderBottom="1px" borderColor="borderColor">
      <Flex align="center" gap={2}>
        <Avatar src={currentUser.main_avatar_url} />
        <Stack spacing={1}>
          <Text>{capitalizeString(currentUser.name)}</Text>
          <Text variant="secondary">{cpfMask(currentUser.cpf_number)}</Text>
        </Stack>
      </Flex>

      <FeatureNotYetAvailable>
        <Search boxSize={5} />
      </FeatureNotYetAvailable>
    </Flex>
  )
}
